import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import React from "react";
import Tooltip from "components/tooltip";
import Skeleton from "@material-ui/lab/Skeleton";

interface Props {
  isLoading?: boolean;
  type: "view" | "click" | "ctr";
  data: number;
}

const StaticsCard: React.FC<Props> = ({ type, data, isLoading }) => {
  if (isLoading) {
    return (
      <div className="w-full h-28 flex flex-col justify-center content-center rounded-2xl">
        <Skeleton variant="rect" height={112} />
      </div>
    );
  }
  switch (type) {
    case "click":
      return (
        <div className="w-full h-28 bg-blue-100 flex flex-col justify-center content-center rounded-2xl">
          <div className="text-center text-2xl font-semibold">{data}</div>
          <div className="text-center text-sm">Lượt click</div>
        </div>
      );
    case "ctr":
      return (
        <div className="w-full h-28 bg-red-100 flex flex-col justify-center content-center rounded-2xl">
          <div className="text-center text-2xl font-semibold">{data}%</div>
          <div className="text-center text-sm">
            {"CTR "}
            <Tooltip title="Chỉ số lượt click trên tổng số lượt xem. (Bằng tổng số lượt click / tổng số lượt xem)">
              <HelpOutlineIcon
                style={{
                  fontSize: "0.875rem",
                  lineHeight: "1.25rem",
                  color: "#000",
                }}
              />
            </Tooltip>
          </div>
        </div>
      );
    case "view":
    default:
      return (
        <div className="w-full h-28 bg-green-100 flex flex-col justify-center content-center rounded-2xl">
          <div className="text-center text-2xl font-semibold">{data}</div>
          <div className="text-center text-sm">Lượt xem</div>
        </div>
      );
  }
};
export default StaticsCard;
